import { Link as RouterLink, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLang } from "../i18n/LangContext";
import { getPost } from "../content/blog";
import { SEOHead, SITE_URL } from "../components/SEOHead";
import { NotFoundPage } from "./NotFoundPage";

export function BlogPostPage() {
  const { t, lang } = useLang();
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPost(slug) : null;

  if (!post) {
    return <NotFoundPage />;
  }

  const url = `${SITE_URL}/blog/${post.slug}`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.description,
    datePublished: post.date,
    inLanguage: lang,
    url,
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
    author: { "@type": "Person", name: "Moritz Habegger" },
  };

  return (
    <>
      <SEOHead
        title={post.title}
        description={post.description}
        path={`/blog/${post.slug}`}
        type="article"
        publishedAt={post.date}
        image={post.image}
        jsonLd={jsonLd}
      />
      <main className="page page--text">
        <Button
          component={RouterLink}
          to="/blog"
          startIcon={<ArrowBackIcon />}
          size="small"
          sx={{ mb: 2, color: "text.secondary" }}
        >
          {t("blogBack")}
        </Button>
        <article className="text-article">
          <header className="post-head">
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {post.date} · {post.readingTime} {t("blogReadingTime")}
            </Typography>
            <Typography
              variant="h3"
              component="h1"
              sx={{ fontWeight: 700, mt: 0.5, letterSpacing: "-0.01em" }}
            >
              {post.title}
            </Typography>
            {post.description && (
              <Typography
                variant="body1"
                sx={{ mt: 1.5, color: "text.secondary", fontSize: 17 }}
              >
                {post.description}
              </Typography>
            )}
          </header>
          <div
            className="post-body"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
        </article>
      </main>
    </>
  );
}
